import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'
import { THEME } from '../config/constants'
import { CategoryIds } from '../../CategoryTabs'
import { Service } from '../types'

export const useServiceData = (): Record<CategoryIds, Service[]> => {
  const features = useFeaturesConfig()

  const widgetCategories: Record<CategoryIds, Service[]> = {
    resumes: [
      {
        id: 'resume_crafting',
        title: 'Resume building',
        enabled: true,
        progress: 0,
        defaultActive: true,
        icon: 'ResumeCrafting',
        component: 'ResumeCrafting',
        theme: THEME.documents,
        getNextActionUrl: () => '?categoryTab=resumes&serviceId=resume_tailoring',
        calculatedProgress: {},
      },
      {
        id: 'resume_tailoring',
        title: 'Resume tailoring',
        progress: 0,
        enabled: true,
        icon: 'ResumeTailoring',
        component: 'ResumeTailoring',
        theme: THEME.documents,
        getNextActionUrl: () => '?categoryTab=resumes&serviceId=resume_distribution',
        calculatedProgress: {},
      },
      {
        id: 'resume_distribution',
        title: 'Resume distribution',
        enabled: features?.showResumeDistribution(),
        progress: 0,
        icon: 'ResumeDistribution',
        component: 'ResumeDistribution',
        theme: THEME.documents,
        getNextActionUrl: () => '?categoryTab=resumes&serviceId=cover_letter_crafting',
        calculatedProgress: {},
      },
      {
        id: 'cover_letter_crafting',
        title: 'Cover letter crafting',
        enabled: true,
        progress: 0,
        icon: 'CoverLetterCrafting',
        component: 'CoverLetterCrafting',
        theme: THEME.documents,
        getNextActionUrl: () => '?categoryTab=jobs&serviceId=job_applications',
        calculatedProgress: {},
      },
    ],
    jobs: [
      {
        id: 'job_applications',
        title: 'Apply for jobs',
        enabled: true,
        progress: 0,
        icon: 'JobsApplied',
        component: 'JobsApplied',
        theme: THEME.jobs,
        getNextActionUrl: () => '?categoryTab=jobs&serviceId=resume_distribution',
        calculatedProgress: {},
      },
      {
        id: 'resume_distribution',
        title: 'Resume distribution',
        enabled: features?.showResumeDistribution(),
        progress: 0,
        icon: 'ResumeDistribution',
        component: 'ResumeDistribution',
        theme: THEME.documents,
        getNextActionUrl: () => '?categoryTab=jobs&serviceId=job_search_strategy',
        calculatedProgress: {},
      },
      {
        id: 'job_search_strategy',
        title: 'Job search strategy',
        enabled: features?.features.jobSearchPlan,
        progress: 0,
        icon: 'JobSearchStrategy',
        component: 'JobSearchStrategy',
        theme: THEME.careers,
        getNextActionUrl: () => '?categoryTab=interview&serviceId=interviews_started',
        calculatedProgress: {},
      },
    ],
    interview: [
      {
        id: 'interviews_started',
        title: 'Interviews practiced',
        enabled: true,
        progress: 0,
        icon: 'InterviewsPracticed',
        component: 'InterviewsPracticed',
        theme: THEME.careers,
        getNextActionUrl: () => '?categoryTab=interview&serviceId=interview_questions',
        calculatedProgress: {},
      },
      {
        id: 'interview_questions',
        title: 'Questions practiced',
        enabled: true,
        progress: 0,
        icon: 'QuestionsPracticed',
        component: 'QuestionsPracticed',
        theme: THEME.careers,
        getNextActionUrl: () => '?categoryTab=interview&serviceId=interview_strategy',
        calculatedProgress: {},
      },
      {
        id: 'interview_strategy',
        title: 'Interview strategy',
        enabled: features?.features.jobSearchPlan,
        progress: 0,
        icon: 'InterviewStrategy',
        component: 'InterviewStrategy',
        theme: THEME.careers,
        getNextActionUrl: () => '?categoryTab=interview&serviceId=interviews_completed',
        calculatedProgress: {},
      },
      {
        id: 'interviews_completed',
        title: 'Interviews passed',
        enabled: true,
        progress: 0,
        icon: 'InterviewsPassed',
        component: 'InterviewsPassed',
        theme: THEME.careers,
        getNextActionUrl: () => '?categoryTab=learning&serviceId=ninety_days_plan',
        calculatedProgress: {},
      },
    ],
    learning: [
      {
        id: 'upskill',
        enabled: !!features?.features?.learningHub,
        title: 'Upskill',
        progress: 0,
        icon: 'Upskill',
        component: 'Upskill',
        theme: THEME.careers,
        getNextActionUrl: () => '?categoryTab=learning&serviceId=ninety_days_plan',
        calculatedProgress: {},
      },
      {
        id: 'ninety_days_plan',
        title: 'First 90-day plan',
        enabled: features?.features?.careerCoaching,
        progress: 0,
        icon: 'First90DaysPlan',
        component: 'First90DaysPlan',
        theme: THEME.careers,
        getNextActionUrl: () => '?categoryTab=learning&serviceId=promotion_plan',
        calculatedProgress: {},
      },
      {
        id: 'promotion_plan',
        title: 'Get a promotion',
        enabled: features?.features?.careerCoaching,
        progress: 0,
        icon: 'GetPromotion',
        component: 'GetPromotion',
        theme: THEME.careers,
        getNextActionUrl: () => '?categoryTab=learning&serviceId=career_switch',
        calculatedProgress: {},
      },
      {
        id: 'career_switch',
        title: 'Change careers',
        enabled: features?.features?.careerCoaching,
        progress: 0,
        icon: 'ChangeCareers',
        component: 'ChangeCareers',
        theme: THEME.careers,
        getNextActionUrl: () => '?categoryTab=resumes&serviceId=resume_crafting',
        calculatedProgress: {},
      },
    ],
  }

  return widgetCategories
}
